










































































































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {
  AttachmentHostType, AuditFlowScope, LecturerDto, TrainApplyDto, TrainRecordDto,
} from "@/api/appService";
import api from "@/api";
import moment from "moment";
import AttachmentsView from "@/components/AttachmentsView/index.vue";
import {AuditBodyDto} from "@/utils/customDto";

import ExamPaperDetail from "@/views/train/trainRecord/component/examPaperDetail.vue";
import AuditBlock, {AuditApi} from "@/components/Audit/AuditBlock.vue";

@Component({
  name: "LecturerDetail",
  components: {
    AuditBlock,
    AttachmentsView,
    ExamPaperDetail
  },
  filters: {
    formatStatus(status?: string) {
      switch (status) {
        case "Draft":
          return "草稿";

        case "Published":
          return "已发布";

        case "Deleted":
          return "已删除";
      }
    },
  },
})
export default class LecturerDetail extends Vue {


  dataId?: number;
  detail: TrainRecordDto = {
    train: {
      trainType: {}
    },
    applyUser: {},
    volunteer: {}
  };
  baseURL: any;
  loading = true;
  hostType = AttachmentHostType.TrainRecord;
  isCanAudit = false


  created() {
    if (this.$route.params.id) {
      this.dataId = Number(this.$route.params.id);
      this.fetchDetail();
    }
  }

  // 获取详情
  async fetchDetail() {
    await api.trainRecord.get({id: this.dataId}).then((res) => {
      this.detail = {...res};

      api.trainRecord.canAudit({body:{id:this.dataId}}).then((res)=>{
        this.isCanAudit = res;
      })
      this.loading = false;
    });
  }

  getTime(item: any) {
    return moment(item).format("HH:mm");
  }

  // 下载附件
  downLoad(item: any) {
    window.location.href = `${this.baseURL}/api/services/app/Attachment/Download?id=${item.id}`;
  }


  get auditApi() {
    return {
      canAudit: api.trainRecord.canAudit,
      userAudit: api.trainRecord.audit
    } as AuditApi
  }
}
